/**
 * 设施服务
 */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import SvgIcon from "@components/icon/svg";

const getMetaIconSymbol = (cacheStore => metaValue => {
  const cached = cacheStore[metaValue];
  if (cached) return cached;
  let symbol;
  try {
    symbol = require(`@shared/icons/metas/meta-${metaValue}.svg`);
  } catch (e) {
    symbol = null;
  }
  cacheStore[metaValue] = symbol;
  return symbol;
})({});

const FacilityList = ({ metaGroups, bedList }) => (
  <ul className="product-facility list-unstyled clearfix">
    {bedList.length > 0 ? (
      <li className="product-bed-group">
        <p className="product-facility-group-title">床型</p>
        <ul className="list-inline">
          {bedList.map(item => (
            <li key={item.metaId} className="product-facility-group-item">
              {item.value}X{item.metaValue}
            </li>
          ))}
        </ul>
        <hr />
      </li>
    ) : null}
    {metaGroups
      .filter(mg => mg.group && mg.group.length > 0)
      .map((mg, index) => (
        <li key={mg.id} className="product-facility-group">
          {index !== 0 && <hr />}
          <p className="product-facility-group-title">{mg.name}</p>
          <ul className="list-unstyled">
            {mg.group.map(item => {
              const metaIcon = getMetaIconSymbol(item.metaId);
              const cn = cx("product-facility-group-item", {
                "product-facility-group-item--no-icon": !metaIcon,
              });
              return (
                <li key={item.metaId} className={cn}>
                  {!metaIcon || <SvgIcon symbol={metaIcon} size="lg" />}
                  <p className="product-facility-group-item__name">{item.value}</p>
                </li>
              );
            })}
          </ul>
        </li>
      ))}
  </ul>
);

FacilityList.defaultProps = {
  metaGroups: [],
  bedList: [],
};

FacilityList.propTypes = {
  metaGroups: PropTypes.array,
  bedList: PropTypes.array,
};

export default FacilityList;

require("./index.less");
require("./index.less");